import React from 'react';
import {
  Box,
  Button,
  Dropdown,
  DropdownOverlay,
  FilterChipSelectInput,
  TextInput,
} from '@razorpay/blade/components';

import { TextFilterChipProps } from './types';
import { getTextInputPlaceholder } from './utils';

export const TextFilterChip = ({
  definition,
  value,
  isOpen,
  isDisabled,
  isClearDisabled,
  onOpenChange,
  onChange,
  onApply,
  onClearButtonClick,
  onClearClick,
}: TextFilterChipProps) => {
  return (
    <Dropdown selectionType="single" isOpen={isOpen} onOpenChange={onOpenChange}>
      <FilterChipSelectInput
        accessibilityLabel={`${definition.label} filter`}
        name={definition.fieldKey}
        label={definition.label}
        value={value}
        isDisabled={isDisabled}
        onChange={() => {}}
        onClearButtonClick={onClearButtonClick}
      />
      <DropdownOverlay minWidth="280px">
        <Box
          display="flex"
          flexDirection="column"
          gap="spacing.4"
          padding="spacing.4"
          width="280px"
        >
          <TextInput
            label={definition.label}
            labelPosition="top"
            accessibilityLabel={`${definition.label} value`}
            value={value}
            placeholder={getTextInputPlaceholder(definition)}
            onChange={({ value: nextValue }) => onChange(nextValue ?? '')}
            isDisabled={isDisabled}
          />
          <Box display="flex" gap="spacing.3" justifyContent="flex-end">
            <Button
              variant="secondary"
              size="small"
              onClick={onClearClick}
              isDisabled={isClearDisabled}
            >
              Clear
            </Button>
            <Button
              variant="primary"
              size="small"
              onClick={onApply}
              isDisabled={isDisabled || !value.trim()}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </DropdownOverlay>
    </Dropdown>
  );
};
